import { make } from "vuex-pathify"
import * as ads from "./ads"
import * as audiences from "./audiences"
import * as targeting from "./targeting"

const state = () => {
  return {
    adsBudgetTypes: ads.ADS_BUDGET_TYPES,
    adsCallToActionTypes: ads.ADS_CALL_TO_ACTION_TYPES,
    adsCustomEventTypes: ads.ADS_CUSTOM_EVENT_TYPES,
    adsPropagationContents: ads.ADS_PROPAGATION_CONTENTS,
    adsCampaignObjectives: ads.ADS_CAMPAIGN_OBJECTIVES,

    audiencesTypes: audiences.AUDIENCES_TYPES,

    targetingGendersTypes: targeting.TARGETING_GENDERS_TYPES,
    targetingGeoLocationsTypes: targeting.TARGETING_GEO_LOCATIONS_TYPES,
    targetingLocationsTypes: targeting.TARGETING_LOCATIONS_TYPES,
  }
}

const actions = {}

const getters = {
  ...make.getters(state),
  findAdsPropagationContents: state => item => {
    const key = typeof item === "object" ? item.key : item

    return state.adsPropagationContents.find(i => i.key === key)
  },

  findAdsCampaignObjectives: state => item => {
    const key = typeof item === "object" ? item.key : item

    return state.adsCampaignObjectives.find(i => i.key === key)
  },

  findAdsCallToActionType: state => item => {
    const key = typeof item === "object" ? item.key : item

    return state.adsCallToActionTypes.find(i => i.key === key)
  },

  findAudienceType: state => item => {
    const key = typeof item === "object" ? item.key : item

    return state.audiencesTypes.find(i => i.key === key)
  },

  findAudienceSubTypes: state => item => {
    const key = typeof item === "object" ? item.key : item

    return state.audiencesTypes.find(i => i.key === key)?.children || []
  },

  findTargetingGenderType: state => item => {
    const key = typeof item === "object" ? item.key : item

    return (
      state.targetingGendersTypes.find(i => i.key === key) || { key, name: key }
    )
  },

  findTargetingGeoLocationType: state => item => {
    const key = typeof item === "object" ? item.key : item

    return (
      state.targetingGeoLocationsTypes.find(i => i.key === key) || {
        key,
        name: key,
      }
    )
  },

  findTargetingLocationType: state => item => {
    const key = typeof item === "object" ? item.key : item

    return (
      state.targetingLocationsTypes.find(i => i.key === key) || {
        key,
        name: key,
      }
    )
  },
}

const mutations = {
  ...make.mutations(state),
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
